var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2607 8.82196V4.13466C17.2607 3.58237 16.813 3.13466 16.2607 3.13466H4.61328C4.061 3.13466 3.61328 3.58237 3.61328 4.13466V19.4318C3.61328 19.9841 4.061 20.4318 4.61328 20.4318H9.37811",
    stroke: "currentColor",
    strokeWidth: 1.57,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28711 8.09424H10.4535",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28711 12H12.0367",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5738 20.8653C13.0213 20.8653 12.5735 20.4173 12.5738 19.8648L12.5746 18.5341C12.5749 18.3723 12.706 18.2413 12.8677 18.2411C13.8445 18.2411 14.8212 18.2411 15.798 18.2411C16.068 18.2411 16.0665 18.0016 16.0665 17.4315C16.0665 16.8614 14.6305 16.3812 14.6305 14.3769C14.6305 12.3726 16.1182 11.7832 17.3545 11.7832C18.5909 11.7832 19.9375 12.3726 19.9375 14.3769C19.9375 16.3812 18.509 16.6998 18.509 17.4315C18.509 18.1631 18.509 18.2411 18.7377 18.2411C19.7103 18.2411 20.6828 18.2411 21.6554 18.2411C21.8172 18.2411 21.9484 18.3723 21.9484 18.5341V19.8653C21.9484 20.4176 21.5007 20.8653 20.9484 20.8653H13.5738Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/合同管理.37cd6305e19c7f00e69d3b6f59a0d2f9.svg";
export { ForwardRef as ReactComponent };